// Modules per family (0029). English counterpart of modulesApp.nl.ts.
export const appModulesEn = {
    title: 'Modules',
    intro: 'Choose which parts your family uses. Turning something off deletes nothing: turn it back on and everything is still there.',
    settingsBody: 'Turn parts on or off, such as drop-off and pick-up',
    on: 'On',
    off: 'Off',
    dependsOn: 'Only works when {names} is on.',
    blockedBy: 'Off because {names} is off.',
    offBecause: 'Off ({names} is off)',
    exampleA: 'Sam',
    exampleB: 'Alex',
    holidaysIslamic: 'Also Eid al-Fitr and Eid al-Adha in your tradition.',
    alsoOff: 'This also turns off {names}.',
    notInPlan: 'Not included in your plan.',
    settings: 'Settings',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: 'Settings for {name}',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'Show all modules',
    showFewer: 'Only what suits us',
    hiddenNote: 'Parts that do not suit your household type are hidden.',
    typeLine: 'Household type: {name}',
    typeChange: 'Change',
    toastOn: '{name} is on',
    toastOff: '{name} is off. Nothing was deleted.',
    toastOption: 'Saved',
    optionNeeds: 'Works when {name} is on.',
    onlyParents: 'Only a parent can change this.',
    kioskNote: 'The tablet follows within a few seconds.',
    groups: {
        agenda: 'Calendar and on the go',
        home: 'Home and together',
        personal: 'Personal',
        faith: 'Faith and tradition',
        board: 'Board and app',
        care: 'Care and family',
    },
    groupCount: '{on} of {total} on',
    search: 'Search modules',
    searchNone: 'No module found for "{q}".',
    options: 'Options ({n})',
    offTitle: '{name} is off',
    offBody: 'This part is turned off for your family. Nothing was deleted.',
    offBodyChild: 'This part is turned off. Ask a parent to turn it on.',
    offAction: 'Go to Modules',
    rides: {
        dropoff: '{name} drops off',
        pickup: '{name} picks up',
        both: '{name} drops off and picks up',
        whoDropoff: 'Who drops off?',
        whoPickup: 'Who picks up?',
        travel: '{minutes} min travel',
        travelWho: '{name} drives · {minutes} min',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} min back',
    },
};
//# sourceMappingURL=modulesApp.en.js.map